export default {
  api: {
    url: 'http://localhost:8000/api/',
  },
  reCaptcha: {
    key: '6LePGkMUAAAAAOTWH0UyO6DIk8yMMgFPF4yrD0kE',
    redirectUrl: 'http://localhost:2000/#/',
  },
};
